"use client";

import * as RadixToast from "@radix-ui/react-toast";
import styles from "./Toast.module.sass";

interface ToastProps {
  icon?: React.ReactNode;
  title: string;
  message: string;
  buttonText?: string;
  onClose: () => void;
  isOpen: boolean;
}

export const Toast = ({ icon, title, message, buttonText, onClose, isOpen }: ToastProps) => {
  return (
    <RadixToast.Provider swipeDirection="right">
      <RadixToast.Root className={styles.Toast} open={isOpen}>
        <RadixToast.Title className={styles.Toast__title}>
          <div className={styles.Toast__checkIcon}>{icon}</div>
          {title}
        </RadixToast.Title>
        <RadixToast.Description asChild>
          <p className={styles.Toast__description}>{message}</p>
        </RadixToast.Description>
      </RadixToast.Root>
      <RadixToast.Viewport />
    </RadixToast.Provider>
  );
};
